import { ChevronDown } from "lucide-react";
import { FAQS } from "../data/site";

export const FaqAccordion = () => (
  <div data-testid="faq-list" className="border-t-2 border-dashed border-amber-900/25">
    {FAQS.map((faq, i) => (
      <details
        key={faq.q}
        className="group border-b-2 border-dashed border-amber-900/25"
        data-testid={`faq-item-${i + 1}`}
      >
        <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 font-heading text-base font-bold text-charcoal transition-colors hover:text-bumbu sm:text-lg [&::-webkit-details-marker]:hidden">
          <span>
            <span className="mr-3 font-mono text-xs font-bold text-bumbu">
              {String(i + 1).padStart(2, "0")}
            </span>
            {faq.q}
          </span>
          <ChevronDown
            className="h-5 w-5 shrink-0 text-bumbu transition-transform duration-200 group-open:rotate-180"
            aria-hidden="true"
          />
        </summary>
        <p className="max-w-3xl pb-6 pl-9 text-sm leading-relaxed text-charcoal-muted sm:text-base">
          {faq.a}
        </p>
      </details>
    ))}
  </div>
);
